var _path;
import * as React from "react";
function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z",
    stroke: "var(--border-disabled)"
  })));
}
export default SvgEllipse;